module.exports = __webpack_public_path__ + "static/img/gpt63.9b19cf56.png";